"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var semiring_1 = require("semiring");
var react_1 = require("react");
var supportedSemirings = {
    "Probability": true,
    "Log": true,
    "Tropical": true,
    "Boolean": true,
    "String": true,
};
function getSemiringComponent(s) {
    switch (s) {
        case "Probability":
            return React.createElement(ProbabilitySemiringComponent, null);
        case "Log":
            return React.createElement(LogSemiringComponent, null);
        case "Tropical":
            return React.createElement(TropicalSemiringComponent, null);
        case "Boolean":
            return React.createElement(BooleanSemiringComponent, null);
        case "String":
    }
    return React.createElement(SemiringComponent, { semiring: s });
}
var SemiringDemo = (function (_super) {
    __extends(SemiringDemo, _super);
    function SemiringDemo() {
        var _this = _super.call(this) || this;
        _this.state = {
            selectedSemiring: "Probability"
        };
        return _this;
    }
    SemiringDemo.prototype.semiringChange = function (selected) {
        this.setState({
            selectedSemiring: selected
        });
    };
    SemiringDemo.prototype.render = function () {
        var _this = this;
        return React.createElement("div", { className: "demo" },
            React.createElement("select", { name: "semirings", className: "mdc-select", onChange: function (e) { return _this.semiringChange(e.target.value); } }, Object.keys(supportedSemirings)
                .map(function (s, i) { return React.createElement("option", { selected: i === 0, key: s, value: s }, s + " semiring"); })),
            getSemiringComponent(this.state.selectedSemiring));
    };
    return SemiringDemo;
}(React.PureComponent));
exports.SemiringDemo = SemiringDemo;
var LEFT_RIGHT = ["Left", "Right"];
var PLUS_TIMES = ["plus", "times"];
function getSemiring(selected) {
    switch (selected) {
        case "Probability":
            return semiring_1.FloatingPointSemiring;
        case "Log":
            return semiring_1.LogSemiring;
        case "Tropical":
            return semiring_1.TropicalSemiring;
        case "Boolean":
            return semiring_1.BooleanSemiring;
        case "String":
            var alphabet = new Set(["a", "b", "c"]);
            return semiring_1.createStringSemiring(alphabet);
        default:
            throw new Error("Unknown semiring: " + selected);
    }
}
function stringified(res) {
    if (res === Infinity)
        return "Infinity";
    else
        return JSON.stringify(res);
}
function renderResult(o, rig, plusLeft, plusRight, timesLeft, timesRight) {
    var res;
    if (o === "plus") {
        res = (rig.plus(plusLeft, plusRight));
    }
    else {
        res = (rig.times(timesLeft, timesRight));
    }
    return stringified(res);
}
function renderEquations(rig, plusLeft, plusRight, timesLeft, timesRight, changeState) {
    return React.createElement("div", { className: "semiring-equations" }, PLUS_TIMES.map(function (o) {
        return React.createElement("div", { key: o, className: "semiring-equation" },
            React.createElement("div", { className: "mdc-form-field mdc-form-field--align-end" },
                React.createElement("div", { className: "mdc-textfield" },
                    React.createElement("input", { id: o + "Left", onChange: function (e) { return changeState(o + "Left", e.target.value); }, type: "text", className: "mdc-textfield__input equation-field" }))),
            React.createElement("span", { className: "operator" }, o === "plus" ? "⊕" : "⊗"),
            React.createElement("div", { className: "mdc-form-field mdc-form-field--align-end" },
                React.createElement("div", { className: "mdc-textfield" },
                    React.createElement("input", { id: o + "Right", onChange: function (e) { return changeState(o + "Right", e.target.value); }, type: "text", className: "mdc-textfield__input equation-field" }))),
            "= ",
            renderResult(o, rig, plusLeft, plusRight, timesLeft, timesRight));
    }));
}
function setInitialCalculations(rig) {
    var s = {};
    LEFT_RIGHT.forEach(function (lr) {
        var valueToSet = (lr === "Left" ? rig.multiplicativeIdentity : rig.additiveIdentity);
        var valueString = stringified(valueToSet);
        PLUS_TIMES.forEach(function (pt) {
            var id = "" + pt + lr;
            var p = document.getElementById(id);
            s[id] = valueToSet;
            if (p)
                p.value = valueString;
        });
    });
    return (s);
}
var SemiringComponent = (function (_super) {
    __extends(SemiringComponent, _super);
    function SemiringComponent(_a) {
        var semiring = _a.semiring;
        var _this = _super.call(this) || this;
        var rig = getSemiring(semiring);
        _this.state = initState(rig);
        return _this;
    }
    SemiringComponent.prototype.componentDidUpdate = function (prevProps, prevState) {
        console.log(this.props.semiring !== prevProps.semiring);
        if (this.props.semiring !== prevProps.semiring)
            this.setState(setInitialCalculations(getSemiring(this.props.semiring)));
    };
    SemiringComponent.prototype.componentDidMount = function () {
        this.setState(setInitialCalculations(getSemiring(this.props.semiring)));
    };
    SemiringComponent.prototype.changeState = function (k, value) {
        var selected = this.props.semiring;
        if ((selected) === "Probability"
            || (selected) === "Log"
            || (selected) === "Tropical") {
            try {
                var number = parseFloat(value);
                switch (k) {
                    case "plusLeft":
                        this.setState({ plusLeft: number });
                        break;
                    case "plusRight":
                        this.setState({ plusRight: number });
                        break;
                    case "timesLeft":
                        this.setState({ timesLeft: number });
                        break;
                    case "timesRight":
                        this.setState({ timesRight: number });
                        break;
                }
            }
            catch (e) {
                console.error(e);
            }
        }
        if (selected === "Boolean") {
            var number = (value.trim().toLowerCase() === "true" ? true : false);
            switch (k) {
                case "plusLeft":
                    this.setState({ plusLeft: number });
                    break;
                case "plusRight":
                    this.setState({ plusRight: number });
                    break;
                case "timesLeft":
                    this.setState({ timesLeft: number });
                    break;
                case "timesRight":
                    this.setState({ timesRight: number });
                    break;
            }
        }
        if (selected === "String") {
            var number = {};
            try {
                number = JSON.parse(value);
            }
            catch (e) {
                console.error("Can't parse " + value);
            }
            switch (k) {
                case "plusLeft":
                    this.setState({ plusLeft: number });
                    break;
                case "plusRight":
                    this.setState({ plusRight: number });
                    break;
                case "timesLeft":
                    this.setState({ timesLeft: number });
                    break;
                case "timesRight":
                    this.setState({ timesRight: number });
                    break;
            }
        }
    };
    SemiringComponent.prototype.render = function () {
        var _this = this;
        try {
            var rig = getSemiring(this.props.semiring);
            var plusRight = this.state.plusRight;
            var plusLeft = this.state.plusLeft;
            var timesRight = this.state.timesRight;
            var timesLeft = this.state.timesLeft;
            console.log(plusLeft + " \u2295 " + plusRight + " = " + rig.plus(plusLeft, plusRight));
            console.log(timesLeft + " \u2297 " + timesRight + " = " + rig.times(timesLeft, timesRight));
            return React.createElement("div", null,
                this.props.semiring === "String"
                    ? React.createElement("p", null,
                        "A semiring of formal languages. Used in automaton theory. (",
                        React.createElement("a", { href: "http://www.openfst.org/twiki/pub/FST/FstHltTutorial/tutorial_part1.pdf" }, "An unweighted functional transducer can be seen as as a weighted automaton over the string semiring."),
                        ")")
                    : "",
                renderEquations(rig, plusLeft, plusRight, timesLeft, timesRight, function (k, value) { return _this.changeState(k, value); }));
        }
        catch (e) {
            return React.createElement("div", { className: "error" }, e.message);
        }
    };
    return SemiringComponent;
}(react_1.PureComponent));
exports.SemiringComponent = SemiringComponent;
function newState(k, number) {
    var s = {};
    s[k] = number;
    return s;
}
var ProbabilitySemiringComponent = (function (_super) {
    __extends(ProbabilitySemiringComponent, _super);
    function ProbabilitySemiringComponent() {
        var _this = _super.call(this) || this;
        _this.rig = semiring_1.FloatingPointSemiring;
        _this.state = initState(_this.rig);
        return _this;
    }
    ProbabilitySemiringComponent.prototype.changeState = function (k, value) {
        try {
            this.setState(newState(k, (parseFloat(value))));
        }
        catch (e) {
            console.error(e);
        }
    };
    ProbabilitySemiringComponent.prototype.componentDidMount = function () {
        this.setState(setInitialCalculations(this.rig));
    };
    ProbabilitySemiringComponent.prototype.render = function () {
        var _this = this;
        try {
            return React.createElement("div", null,
                React.createElement("p", null, "This semiring implements the common notion of calculating probabilties through addition and multiplication."),
                renderEquations(semiring_1.FloatingPointSemiring, this.state.plusLeft, this.state.plusRight, this.state.timesLeft, this.state.timesRight, function (k, value) { return _this.changeState(k, value); }));
        }
        catch (e) {
            return React.createElement("div", { className: "error" }, e.message);
        }
    };
    return ProbabilitySemiringComponent;
}(react_1.PureComponent));
exports.ProbabilitySemiringComponent = ProbabilitySemiringComponent;
var LogSemiringComponent = (function (_super) {
    __extends(LogSemiringComponent, _super);
    function LogSemiringComponent() {
        var _this = _super.call(this) || this;
        _this.rig = semiring_1.LogSemiring;
        _this.state = initState(_this.rig);
        return _this;
    }
    LogSemiringComponent.prototype.changeState = function (k, value) {
        try {
            this.setState(newState(k, (parseFloat(value))));
        }
        catch (e) {
            console.error(e);
        }
    };
    LogSemiringComponent.prototype.componentDidMount = function () {
        this.setState(setInitialCalculations(this.rig));
    };
    LogSemiringComponent.prototype.render = function () {
        var _this = this;
        try {
            return React.createElement("div", null,
                React.createElement("p", null, "A semiring usually used for multiplying numbers close to zero, to avoid arithmetic underflow."),
                renderEquations(this.rig, this.state.plusLeft, this.state.plusRight, this.state.timesLeft, this.state.timesRight, function (k, value) { return _this.changeState(k, value); }));
        }
        catch (e) {
            return React.createElement("div", { className: "error" }, e.message);
        }
    };
    return LogSemiringComponent;
}(react_1.PureComponent));
exports.LogSemiringComponent = LogSemiringComponent;
var TropicalSemiringComponent = (function (_super) {
    __extends(TropicalSemiringComponent, _super);
    function TropicalSemiringComponent() {
        var _this = _super.call(this) || this;
        _this.rig = semiring_1.LogSemiring;
        _this.state = {
            plusLeft: _this.rig.multiplicativeIdentity,
            plusRight: _this.rig.additiveIdentity,
            timesLeft: _this.rig.multiplicativeIdentity,
            timesRight: _this.rig.additiveIdentity,
        };
        return _this;
    }
    TropicalSemiringComponent.prototype.changeState = function (k, value) {
        try {
            this.setState(newState(k, (parseFloat(value))));
        }
        catch (e) {
            console.error(e);
        }
    };
    TropicalSemiringComponent.prototype.componentDidMount = function () {
        this.setState(setInitialCalculations(this.rig));
    };
    TropicalSemiringComponent.prototype.render = function () {
        var _this = this;
        try {
            return React.createElement("div", null,
                React.createElement("p", null,
                    "A semiring that describes ",
                    React.createElement("a", { href: "https://en.wikipedia.org/wiki/Tropical_geometry" }, "Tropical geometry"),
                    ". An interesting application of this semiring was made by ",
                    React.createElement("a", { href: "https://www.theguardian.com/science/video/2013/jul/12/geometry-banking-crisis-video" }, "Paul Klemperer for use in auctions during the financial crisis"),
                    "."),
                renderEquations(this.rig, this.state.plusLeft, this.state.plusRight, this.state.timesLeft, this.state.timesRight, function (k, value) { return _this.changeState(k, value); }));
        }
        catch (e) {
            return React.createElement("div", { className: "error" }, e.message);
        }
    };
    return TropicalSemiringComponent;
}(react_1.PureComponent));
exports.TropicalSemiringComponent = TropicalSemiringComponent;
var StringSemiringComponent = (function (_super) {
    __extends(StringSemiringComponent, _super);
    function StringSemiringComponent() {
        var _this = _super.call(this) || this;
        _this.rig = semiring_1.LogSemiring;
        _this.state = {
            plusLeft: _this.rig.multiplicativeIdentity,
            plusRight: _this.rig.additiveIdentity,
            timesLeft: _this.rig.multiplicativeIdentity,
            timesRight: _this.rig.additiveIdentity,
        };
        return _this;
    }
    StringSemiringComponent.prototype.changeState = function (k, value) {
        try {
            this.setState(newState(k, (parseFloat(value))));
        }
        catch (e) {
            console.error(e);
        }
    };
    StringSemiringComponent.prototype.componentDidMount = function () {
        this.setState(setInitialCalculations(this.rig));
    };
    StringSemiringComponent.prototype.render = function () {
        var _this = this;
        try {
            return React.createElement("div", null,
                React.createElement("p", null,
                    "A semiring that describes ",
                    React.createElement("a", { href: "https://en.wikipedia.org/wiki/Tropical_geometry" }, "Tropical geometry"),
                    ". An interesting application of this semiring was made by ",
                    React.createElement("a", { href: "https://www.theguardian.com/science/video/2013/jul/12/geometry-banking-crisis-video" }, "Paul Klemperer for use in auctions during the financial crisis"),
                    "."),
                renderEquations(this.rig, this.state.plusLeft, this.state.plusRight, this.state.timesLeft, this.state.timesRight, function (k, value) { return _this.changeState(k, value); }));
        }
        catch (e) {
            return React.createElement("div", { className: "error" }, e.message);
        }
    };
    return StringSemiringComponent;
}(react_1.PureComponent));
exports.StringSemiringComponent = StringSemiringComponent;
function initState(rig) {
    return {
        plusLeft: rig.multiplicativeIdentity,
        plusRight: rig.additiveIdentity,
        timesLeft: rig.multiplicativeIdentity,
        timesRight: rig.additiveIdentity,
    };
}
var BooleanSemiringComponent = (function (_super) {
    __extends(BooleanSemiringComponent, _super);
    function BooleanSemiringComponent() {
        var _this = _super.call(this) || this;
        _this.rig = semiring_1.BooleanSemiring;
        _this.state = initState(_this.rig);
        return _this;
    }
    BooleanSemiringComponent.prototype.changeState = function (k, value) {
        try {
            var val = (value.trim().toLowerCase() === "true");
            this.setState(newState(k, val));
        }
        catch (e) {
            console.error(e);
        }
    };
    BooleanSemiringComponent.prototype.componentDidMount = function () {
        this.setState(setInitialCalculations(this.rig));
    };
    BooleanSemiringComponent.prototype.render = function () {
        var _this = this;
        try {
            return React.createElement("div", null,
                React.createElement("p", null, "A semiring that represents Boolean logic: AND, OR, TRUE and FALSE."),
                renderEquations(this.rig, this.state.plusLeft, this.state.plusRight, this.state.timesLeft, this.state.timesRight, function (k, value) { return _this.changeState(k, value); }));
        }
        catch (e) {
            return React.createElement("div", { className: "error" }, e.message);
        }
    };
    return BooleanSemiringComponent;
}(react_1.PureComponent));
exports.BooleanSemiringComponent = BooleanSemiringComponent;



//////////////////
// WEBPACK FOOTER
// ./src/ts/components/SemiringDemo.tsx
// module id = 1
// module chunks = 0